module.exports = __webpack_public_path__ + "img/side.839e8f70.png";